import type { FC, SVGProps } from 'react';

import { StaticButton, type Props as StaticButtonProps } from './StaticButton';

export type IconStaticButtonProps = Omit<
  StaticButtonProps,
  'startIcon' | 'endIcon' | 'children' | 'isContentVisuallyHidden'
> & {
  icon: FC<SVGProps<SVGSVGElement>>;
};

export function IconStaticButton({ icon, ...rest }: IconStaticButtonProps) {
  return <StaticButton {...rest} startIcon={icon} isContentVisuallyHidden />;
}
